import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsAudacityComponent } from './simple-icons-audacity.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsAudacityComponent ],
    exports:      [ SimpleIconsAudacityComponent ],
    bootstrap:    []
})
export class SimpleIconsAudacityModule {}
